import { ServiceDefinition } from '@pershing/pershing-core';

export class PortalComponentServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition;

    uri: string = 'services/netxclient.rest-service';
    version: string = 'v1';
    family: string = 'netxinvestor';
    appName: string = 'rest-service';
    serviceName: string = 'app';
    mnemonic: string = 'nxc';

    static getInstance(): ServiceDefinition {
        if (!PortalComponentServiceDefinition.instance) {
            PortalComponentServiceDefinition.instance = new PortalComponentServiceDefinition();
        }
        return PortalComponentServiceDefinition.instance;
    }
    private constructor() {}
}
